// 当前地图方案
export default {
    namespaced: true,
    state: {
        currentScenario: 'unknown'
    },
    mutations: {
        setScenario(state, type) {
            state.currentScenario = type
        }
    }
}
